import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arJSON from './translations/ar';
import enJSON from './translations/en';
import frJSON from './translations/fr';
import nlJSON from './translations/nl';
import uaJSON from './translations/ua';

const resources = {
  ar: { translation: arJSON },
  en: { translation: enJSON },
  fr: { translation: frJSON },
  ua: { translation: uaJSON },
  nl: { translation: nlJSON }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    keySeparator: false,
    lng: i18n.options.lng,
    fallbackLng: 'en',
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
